import { Box, Flex, Text, Input, Image, Badge, InputGroup, InputLeftElement, Popover, PopoverTrigger, PopoverContent, PopoverBody, useDisclosure, PopoverCloseButton, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, Grid, GridItem, FormControl, FormLabel, Select, Textarea, Center, Spinner, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, } from '@chakra-ui/react';
import MyDiv from './closedJobs.style';
import FilterIcon from '../../../../assets/images/Filter.svg';
import SortIcon from '../../../../assets/images/SortIcon.svg';
import { SearchIcon } from '@chakra-ui/icons';
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router";
import * as routesNames from '../../../../constants/routes';
import { CustomPagination, CustomTable, CustomToast, FilterPopover } from '../../../../components';
import { ILazyParams, useFetch } from '../../../../hooks/useFetch';
import { IFilterOptions } from '../../../../components/FilterCard/filterCard';
import { Column } from '../../../../components/CustomTable/customTable';
import { showDate } from '../../../../utilities/helper';
import { HeaderWithTooltip } from '../ActiveJobs/activeJobs';

const sortOptions = [
  'Job Title (A–Z)',
  'Job Title (Z–A)',
  'Department (A–Z)',
  'Department (Z–A)',
  'Created At- Newest First',
  'Created At- Oldest First',
];

const sortMapping: Record<string, { field: string; order: 1 | -1 }> = {
  'Job Title (A–Z)': { field: 'job_Profile_Name', order: 1 },
  'Job Title (Z–A)': { field: 'job_Profile_Name', order: -1 },
  'Department (A–Z)': { field: 'department_Name', order: 1 },
  'Department (Z–A)': { field: 'department_Name', order: -1 },
  'Created At- Newest First': { field: 'job_Code', order: -1 },
  'Created At- Oldest First': { field: 'job_Code', order: 1 },
};

const ClosedJobs = () => {
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const [reload, setReload] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selected, setSelected] = useState<string>(sortOptions[0]);
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editingJob, setEditingJob] = useState<any | null>(null);
  const [jobOpenings, setJobOpenings] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [selectedJD, setSelectedJD] = useState<string>('');

  const [filter, setFilter] = useState<IFilterOptions>({ filterOptions: {} });
  const [query, setQuery] = useState<{ lazyParams: ILazyParams, filter?: Record<string, number[]>; }>({
    lazyParams: { first: 0, rows: 10, page: 0, sortField: '', sortOrder: 1 },
    filter: {},
  });

  async function loadEmployeeFilter() {
    const response = await fetchApi<IFilterOptions>('Filters/OpenJobFilter', 'GET', null, null, '');
    if (response) {
      setFilter(response);
    }
  }

  const pageCount = Math.ceil(totalCount / query.lazyParams.rows);
  const handlePageClick = ({ selected }: { selected: number }) => {
    setQuery(prev => {
      const updatedParams = {
        ...prev.lazyParams,
        page: selected,
        first: selected * prev.lazyParams.rows,
      };
      return { ...prev, lazyParams: updatedParams };
    });
  };

  const setRowsPerPage = (rows: number) => {
    setQuery((prev) => {
      const updatedParams = {
        ...prev.lazyParams,
        rows,
        page: 0,
        first: 0,
      };
      return { ...prev, lazyParams: updatedParams };
    });
  };

  const handleEdit = (job: any) => {
    setEditingJob(job);
    setDrawerOpen(true);
  };

  const handleSelect = (option: string) => {
    setSelected(option);
    const sortConfig = sortMapping[option];
    if (sortConfig) {
      setQuery(prev => ({
        ...prev,
        lazyParams: {
          ...prev.lazyParams,
          sortField: sortConfig.field,
          sortOrder: sortConfig.order,
          page: 0,
          first: 0
        }
      }));
    }
    onClose();
  };

  const handleStatusChange = async (job: any, newStatus: string) => {
    try {
      const updatedStatus = newStatus === 'Active';

      const res = await fetchApi("JobOpening/StatusUpdate", "PUT", { id: job.id, status: updatedStatus }, "", `Job marked as ${newStatus}`);

      if (res) {
        setJobOpenings((prevJobs) =>
          prevJobs.map((j) =>
            j.id === job.id ? { ...j, status: updatedStatus } : j
          )
        );
      }
    } catch (error) {
      console.error("Error updating job status:", error);
    }
  };


  const candidateList = (jobId: any, type?: string) => {
    navigate(routesNames.CANDIDATELIST, {
      state: {
        jobId: jobId.id, Job_profile: jobId.job_Profile_Name, hideAddButton: true, filterType: type,
      }
    });
  }

  const loadActiveJob = async (filterValue = '') => {
    const queryParams = new URLSearchParams({
      lazyParams: JSON.stringify(query.lazyParams),
      status: "false",
      search: filterValue.trim() === "" ? "" : filterValue,
      filter: JSON.stringify(query.filter ?? {}),
    }).toString();

    const response = await fetchApi("JobOpening/closingjobs", "GET", "", queryParams, "");
    if (response) {
      setJobOpenings(response.data);
      setTotalCount(response.totalCount);
    }
  }
  useEffect(() => {
    loadActiveJob();
  }, [reload])

  const urgencyMap: Record<number, string> = {
    1: "Low",
    2: "Medium",
    3: "High",
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      loadActiveJob(searchQuery);
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [searchQuery, query.lazyParams]);

  useEffect(() => {
    loadEmployeeFilter();
  }, []);


  const handleOpenJD = (jd: string) => {
    setSelectedJD(jd);
    onOpen();
  };

  return (
    <MyDiv>
      <Grid className='grid_container'>
        <GridItem colSpan={12}>
          <Box className="page_wrapper ">
            <Flex className="page_heading flex_header">
              <Text className="font-poppins text_3xl text_semibold">Closed Jobs</Text>
              <Flex className="filter_section">
                <InputGroup maxW="200px">
                  <InputLeftElement pointerEvents="none">
                    <SearchIcon color="gray.400" />
                  </InputLeftElement>
                  <Input placeholder="Search Job Title" onChange={(e) => setSearchQuery(e.target.value)} />
                </InputGroup>

                <Popover placement="bottom-end" closeOnBlur>
                  <PopoverTrigger>
                    <Image src={FilterIcon} alt="Filter" className='icon_btn' />
                  </PopoverTrigger>
                  <FilterPopover filter={filter} onApplyFilter={(filters) => {
                    const _filter: Record<string, number[]> = {};
                    Object.keys(filters).forEach((key) => {
                      if (filters[key].length > 0) {
                        _filter[key.replace(' ', '')] = filters[key];
                      }
                    });
                    setQuery(prev => { return { ...prev, lazyParams: { ...prev.lazyParams, page: 0, first: 0 }, filter: _filter }; });
                  }}
                  />

                </Popover>

                <Popover placement="bottom-end" closeOnBlur>
                  <PopoverTrigger>
                    <Image src={SortIcon} alt="Sort" className='icon_btn' />
                  </PopoverTrigger>
                  <PopoverContent w="270px" borderRadius="10px" boxShadow="md" textAlign={'center'}>
                    <Box px={4} py={2} borderBottom="1px solid #eee">
                      <Text className='font-poppins text_sm text_medium' textAlign="center" color={"#00000080"}>Sort By</Text>
                      <PopoverCloseButton top="8px" right="12px" />
                    </Box>
                    <PopoverBody p={0}>
                      {sortOptions.map((option) => (
                        <Box
                          key={option}
                          px={4}
                          py={2}
                          cursor="pointer"
                          bg={selected === option ? '#EBEBEB' : 'white'}
                          _hover={{ bg: '#EBEBEB' }}
                          onClick={() => handleSelect(option)}
                        >
                          <Text className='font-poppins font_dark' fontSize="14px" fontWeight={selected === option ? '500px' : '500px'}>{option}</Text>
                        </Box>
                      ))}
                    </PopoverBody>
                  </PopoverContent>
                </Popover>
              </Flex>
            </Flex>
            <Box position="relative" minH="300px">
              {loading ? (
                <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                  <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                </Center>
              ) : (
                <>
                  <CustomTable value={jobOpenings} emptyMessage="No Job Openings Available">
                    <Column header="S. No" body={(_, index) => index + 1} />
                    {/* <Column header="Job Code" field="job_Code" /> */}
                    <Column header="Job Code" field="job_Code" body={(row: any) => (
                      <Button variant="link" className="job font-poppins text_sm text_regular" size="sm" colorScheme="blue" onClick={() => candidateList(row)}>
                        {row.job_Code}
                      </Button>
                    )} />
                    <Column header="Job Titles" body={(row: any) => (
                      <Badge variant="subtle" className="job font-poppins text_sm text_regular" onClick={() => handleOpenJD(row.jd_Description)}>
                        {row.job_Profile_Name}
                      </Badge>
                    )}
                    />

                    <Column header="Payroll Company" field="payroll_Company_Name" />
                    <Column header="Company" field="company_Name" />
                    <Column header="Branch" field="branch_Name" />
                    <Column header="Department" field="business_Process_Name" />
                    <Column header={<HeaderWithTooltip short="S.Department" full="Sub Department" />} field="department_Name" />
                    <Column header={<HeaderWithTooltip short="Open." full="Number of Openings" />} field="number_Of_Openings" />
                    <Column header={<HeaderWithTooltip short="Appl." full="Applied Candidates" />} body={(row: any) => (
                      <Text color="blue.500" fontWeight="500" fontSize="14px" cursor="pointer" textDecor="underline" onClick={() => candidateList(row, "applied")}>
                        {row.appliedCount}
                      </Text>
                    )}
                    />
                    <Column header={<HeaderWithTooltip short="Int." full="Interviewed Candidates" />} body={(row: any) => (
                      <Text color="blue.500" fontWeight="500" fontSize="14px" cursor="pointer" textDecor="underline" onClick={() => candidateList(row, "interviewed")}>
                        {row.interviewCount}
                      </Text>
                    )}
                    />
                    <Column header={<HeaderWithTooltip short="LOI." full="Loi Sent" />} body={(row: any) => (
                      <Text color="blue.500" fontWeight="500" fontSize="14px" cursor="pointer" textDecor="underline" onClick={() => candidateList(row, "loiSent")}>
                        {row.loiCount}
                      </Text>
                    )}
                    />
                    <Column header={<HeaderWithTooltip short="Acc." full="Accepted Candidates" />} body={(row: any) => (
                      <Text color="blue.500" fontWeight="500" fontSize="14px" cursor="pointer" textDecor="underline" onClick={() => candidateList(row, "acceptedCount")}>
                        {row.acceptedCount}
                      </Text>
                    )}
                    />
                    <Column header={<HeaderWithTooltip short="Joi." full="Joined Candidates" />} body={(row: any) => (
                      <Text color="blue.500" fontWeight="500" fontSize="14px" cursor="pointer" textDecor="underline" onClick={() => candidateList(row, "joined")}>
                        {row.joinedCount}
                      </Text>
                    )}
                    /><Column header={<HeaderWithTooltip short="Back." full="Backout Candidates" />} body={(row: any) => (
                      <Text color="blue.500" fontWeight="500" fontSize="14px" cursor="pointer" textDecor="underline" onClick={() => candidateList(row, "backout")}>
                        {row.backoutCount}
                      </Text>
                    )}
                    />
                    <Column header="Status" body={(row: any) => (
                      <Box display="flex" alignItems="center" justifyContent="center" w="full">
                        <Select size="sm" width="99px" borderRadius="6px" border="1px solid #ccc" bg={row.status ? '#E5F2E5' : '#ffe5e5ff'} color={row.status ? '#008000' : '#d43434ff'} fontSize="12px" fontWeight="400" className="font-poppins" value={row.status ? 'Active' : 'Closed'} onChange={(e) => handleStatusChange(row, e.target.value)} _focus={{ boxShadow: 'none', outline: 'none' }} _hover={{ cursor: 'pointer' }}>
                          <option style={{ color: '#008000' }} value="Active">
                            Active
                          </option>
                          <option style={{ color: '#FFA500' }} value="Closed">
                            Closed
                          </option>
                        </Select>
                      </Box>
                    )} />
                    <Column header={<HeaderWithTooltip short="O.Date" full="Job Opening Date" />} body={(row) => showDate(row.job_Opening_Date)} field='job_Opening_Date' />
                    <Column header={<HeaderWithTooltip short="C.Date" full="Job Closing Date" />} body={(row) => showDate(row.job_Closing_Date)} field='job_Closing_Date' />
                    <Column header={<HeaderWithTooltip short="By" full="Created By" />} field="created_By" />
                    <Column header={<HeaderWithTooltip short="On" full="Created At" />} field='createdAt' body={r => showDate(r.createdAt)} />
                    <Column header="Action" body={(job) => (
                      <Text className="view font-poppins text_sm text_regular" onClick={() => handleEdit(job)} >
                        View
                      </Text>
                    )}
                    />
                  </CustomTable>

                </>)}
            </Box>
            <CustomPagination pageCount={pageCount} handlePageClick={handlePageClick} rowsPerPage={query.lazyParams.rows} setRowsPerPage={setRowsPerPage} totalRecords={totalCount} currentPage={query.lazyParams.page} rowsPerPageOptions={[10, 50, 200, 500]} />
          </Box>
        </GridItem>
      </Grid>

      <Drawer isOpen={drawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="lg">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">
            Job Details
          </DrawerHeader>
          <DrawerBody>
            <Box py={2}>
              <Text className="font-poppins text_medium text_lg">Basic Information</Text>
              <Flex gap={8} mt={2}>
                <FormControl mb={2} >
                  <FormLabel className="font-poppins text_regular text_md">Payroll Company</FormLabel>
                  <Input name="payrollCompany" type="text" value={editingJob?.payroll_Company_Name || ""} isReadOnly />
                </FormControl>
                <FormControl mb={3} >
                  <FormLabel className="font-poppins text_regular text_md">Branch</FormLabel>
                  <Input name="branch" type="text" value={editingJob?.branch_Name || ""} isReadOnly />
                </FormControl>
              </Flex>
              <Flex gap={8} mt={2}>
                <FormControl mb={3} >
                  <FormLabel className="font-poppins text_regular text_md">Department</FormLabel>
                  <Input name="department" type="text" value={editingJob?.department_Name || ""} isReadOnly />
                </FormControl>
                <FormControl mb={3} >
                  <FormLabel className="font-poppins text_regular text_md"> Job Title</FormLabel>
                  <Input name="jobTitle" type="text" value={editingJob?.job_Profile_Name || ""} isReadOnly />
                </FormControl>
              </Flex>

              <Flex gap={8}>
                <FormControl mb={3} >
                  <FormLabel className="font-poppins text_regular text_md">Number of openings</FormLabel>
                  <Input name="NumberOfOpenings" type="number" placeholder="Enter Number of Opening" value={editingJob?.number_Of_Openings || ""} isReadOnly />
                </FormControl>
                <FormControl mb={3} >
                  <FormLabel className="font-poppins text_regular text_md">Job Opening Date</FormLabel>
                  <Input value={showDate(editingJob?.job_Opening_Date)} isReadOnly />
                </FormControl>
              </Flex>

              <Flex gap={8}>
                <FormControl mb={3} >
                  <FormLabel className="font-poppins text_regular text_md">Job Closing Date</FormLabel>
                  <Input value={showDate(editingJob?.job_Closing_Date)} isReadOnly />
                </FormControl>
                <FormControl mb={3} >
                  <FormLabel className="font-poppins text_regular text_md">Employement Type</FormLabel>
                  <Input name="employmentType" type="text" value={editingJob?.employement_Type || ""} isReadOnly />
                </FormControl>
              </Flex>

              <Flex gap={8}>
                <FormControl mb={3} >
                  <FormLabel className="font-poppins text_regular text_md">Number of openings</FormLabel>
                  <Input name="NumberOfOpenings" type="number" placeholder="Enter Number of Opening" value={editingJob?.number_Of_Openings || ""} isReadOnly />
                </FormControl>
                <FormControl mb={3} >
                  <FormLabel className="font-poppins text_regular text_md">Expected Date of Joining</FormLabel>
                  <Input value={showDate(editingJob?.expected_Date_Of_Joining)} isReadOnly />
                </FormControl>
              </Flex>

              <Flex gap={8}>
                <FormControl mb={3} >
                  <FormLabel className="font-poppins text_regular text_md">Urgency Level</FormLabel>
                  <Input
                    name="urgencyLevel"
                    type="text"
                    value={urgencyMap[editingJob?.urgency_Level ?? 0] || "Not Specified"}
                    isReadOnly
                  />
                </FormControl>
                <FormControl mb={3} >
                  <FormLabel className="font-poppins text_regular text_md">Work Mood</FormLabel>
                  <Input name="workMood" type="text" value={editingJob?.work_Mood || ""} isReadOnly />
                </FormControl>
              </Flex>

              <Flex gap={8}>
                <FormControl mb={3} >
                  <FormLabel className="font-poppins text_regular text_md">Created By</FormLabel>
                  <Input name="createdBy" type="text" value={editingJob?.created_By || ""} isReadOnly />
                </FormControl>
                <FormControl >
                  <FormLabel className="font-poppins text_regular text_md">Skills</FormLabel>
                  <Input name="skill" type="text" value={editingJob?.skillNames || ""} isReadOnly />
                </FormControl>
              </Flex>

              <Text className="font-poppins text_medium text_lg">
                Additional Details
              </Text>
              <Flex gap={8} mt={2}>
                <FormControl mb={3} >
                  <FormLabel className="font-poppins text_regular text_md">Experience Level</FormLabel>
                  <Input
                    type="text"
                    placeholder="Enter Min/Max Experience"
                    value={
                      editingJob
                        ? `${editingJob.experience_From || 0} - ${editingJob.experience_To || 0} Years`
                        : ""
                    }
                    isReadOnly
                  />

                </FormControl>
                <FormControl mb={3} >
                  <FormLabel className="font-poppins text_regular text_md">Salary Range</FormLabel>
                  <Flex gap={8}>
                    <Input type="number" placeholder="e.g 20,00" value={editingJob?.salaryRange || ""} isReadOnly />
                  </Flex>
                </FormControl>
              </Flex>

              <Text className="font-poppins text_medium text_lg">Job Description </Text>
              <FormControl mb={3} mt={2}>
                <FormLabel className="font-poppins text_regular text_md"> Job Summary </FormLabel>
                <Box
                  className="font-poppins text_sm text_medium"
                  pl={5}
                  borderWidth="1px"
                  borderRadius="md"
                  dangerouslySetInnerHTML={{
                    __html: editingJob?.jd_Description || "<p>No description available</p>"
                  }}
                />
              </FormControl>

            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>


      <Modal isOpen={isOpen} onClose={onClose} size="5xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Job Description</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div className="font-poppins text_regular text_md" style={{ whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{ __html: selectedJD || "" }} />
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose} colorScheme="green">Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </MyDiv>
  );
};

export default ClosedJobs;